import { useMutation } from '@tanstack/react-query'
import apiClientPlatform from '@/apiClientPlatform'
import type { PlatformLoginBody, PlatformLoginResponse } from '@/types/platform'
import { usePlatformStore } from '@/store/PlatformStore'

export const usePlatformLoginMutation = () => {
  const { dispatch } = usePlatformStore()

  return useMutation({
    mutationFn: async (payload: PlatformLoginBody) => {
      const { data } = await apiClientPlatform.post<PlatformLoginResponse>(
        `/platform/auth/login`,
        payload
      )
      return data
    },
    onSuccess: (data) => {
      localStorage.setItem('platformUserInfo', JSON.stringify(data))
      dispatch({ type: 'PLATFORM_SIGNIN', payload: data })
    },
  })
}

export const usePlatformLogout = () => {
  const { dispatch } = usePlatformStore()
  return () => {
    localStorage.removeItem('platformUserInfo')
    dispatch({ type: 'PLATFORM_SIGNOUT' })
  }
}
